import { Component, Prop, h, Element, State, Watch } from "@stencil/core";

@Component({
  tag: "snt-promo-banner",
  styleUrl: "promo-banner-component.scss",
  shadow: false,
})
export class ResponsiveBanner {

  @Prop() promoContentString: string = "";
  @Prop() rotationDelay: number = 5;
  @Prop() backgroundColor: string = "";

  @State() currentContentShown: number = 0;
  @State() autoRotate: boolean = true;
  @State() animationClass: string = "";
  @State() leftChevronOn: boolean = false;
  @State() rightChevronOn: boolean = true;
  @Element() el: HTMLElement;

  @Watch("currentContentShown")
  currentContentShownChanged() {
    this.updateChevronStates();
  }

  rotationTimer = null;
  promoContent = JSON.parse(this.promoContentString?.replace(/&quot;/g, '"'))
  useChevrons: boolean = this.promoContent.length > 1;
  chevronVisible: string = this.useChevrons ? "visible" : "hidden";

  renderTags(tagType = "new", tagText = "New!", isPhoneWithChevron = false) {
    let tagStyle;
    if (tagType === "new") {
      tagStyle = "new-style";
    } else if (tagType === "exclusive") {
      tagStyle = "exclusive-style";
    }

    return (
      <span
        class={`tag ${tagStyle} ${isPhoneWithChevron && "tag-with-chevron"}`}
      >
        {tagText}
      </span>
    );
  }
  handleAutoRotate = () => { // Auto rotate has different behavior than chevrons
    this.animationClass = "slide-out-to-left";
    setTimeout(() => {
      this.currentContentShown = (this.currentContentShown + 1) % this.promoContent.length;
      this.animationClass = "slide-in-from-right";
    }, 500);
  };

  handleChevronRight = () => {
    this.animationClass = "slide-out-to-left";
    setTimeout(() => {
      this.currentContentShown = (this.currentContentShown + 1) % this.promoContent.length;
      this.animationClass = "slide-in-from-right";
    }, 500);
    this.autoRotate = false;
    this.stopTimer();
  };

  handleChevronLeft = () => {
    this.animationClass = "slide-out-to-right";
    setTimeout(() => {
      this.currentContentShown = (this.currentContentShown - 1 + this.promoContent.length) % this.promoContent.length;
      this.animationClass = "slide-in-from-left";
    }, 500);
    this.autoRotate = false;
    this.stopTimer();
  }

  handleKeyDownRight = (event) => {
    if (event.key === "Enter" && this.rightChevronOn) {
      this.handleChevronRight();
    }
  };

  handleKeyDownLeft = (event) => {
    if (event.key === "Enter" && this.leftChevronOn) {
      this.handleChevronLeft();
    }
  };

  startTimer = () => {
    if (!this.autoRotate) {
      return;
    }
    this.rotationTimer = setInterval(() => {
      this.handleAutoRotate();
    }, this.rotationDelay * 1000);
  };

  stopTimer = () => {
    clearInterval(this.rotationTimer);
  };

  handleMouseEnter = () => {
    this.stopTimer();
  };

  handleMouseLeave = () => {
    this.startTimer();
  };


  updateChevronStates = () => {
    this.leftChevronOn = this.currentContentShown !== 0;
    this.rightChevronOn = this.currentContentShown !== this.promoContent.length - 1;
  };

  componentDidLoad() {
    // We need to add sticky to the wrapping content-wrapper or else it wont work
    const contentWrapper = this.el.closest(".content-wrapper") as HTMLElement;
    if (contentWrapper) {
      contentWrapper.style.position = "sticky";
      contentWrapper.style.bottom = "0";
    }

    this.updateChevronStates();

    if (this.promoContent.length < 2) {
      this.autoRotate = false;
    } else {
      this.startTimer();
    }
  }

  render() {
    return (
      <div
        class="banner-container"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div class="banner"
         style={{backgroundColor:this.backgroundColor}}>
          <div
            tabIndex={0}
            class={
              "chevron " +
              this.chevronVisible +
              `${this.leftChevronOn === false && " disabled-chevron"}` +
              `${this.useChevrons && " chevron-left"}`
            }
            onClick={() => this.handleChevronLeft()}
            onKeyDown={this.handleKeyDownLeft}
          >
            &#x276E;
          </div>

          <div class="promo-content-wrapper">
            {this.promoContent.map((pc, idx) => {
              return (
                <div
                  class={"promo-content-container" + ` ${this.animationClass}`}
                  style={{
                    display: this.currentContentShown === idx ? "block" : "none",
                  }}
                >
                  <div class="tags">
                    {this.renderTags(pc.tagType, pc.tagText)}
                  </div>
                  <div class="promo-text">
                    {pc.promoText}
                    <div class="vertical-separator"></div>
                    <snt-link class="promo-link" href={pc.learnMoreUrl}>
                      {pc.learnMoreText}
                    </snt-link>
                  </div>
                </div>
              );
            })}
          </div>

          <div
            tabIndex={0}
            class={
              "chevron " +
              this.chevronVisible +
              `${this.rightChevronOn === false && " disabled-chevron"}` +
              `${this.useChevrons && " chevron-right"}`
            }
            onClick={() => this.handleChevronRight()}
            onKeyDown={this.handleKeyDownRight}
          >
            &#x276F;
          </div>
        </div>
      </div>
    );
  }
}
